import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ShippingPack } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ShippingPackService extends TmsWebBaseEditCreateService<ShippingPack, ShippingPack> {
  constructor() {
    super('ShippingPack', $localize`Shipping Pack`);
  }

  getForSupplier(id: string): Observable<ShippingPack[]> {
    return this.httpService.get<ShippingPack[]>(`${this.apiUrl}/GetForSupplier?id=${id}`);
  }

  getForUserSupplier(): Observable<ShippingPack[]> {
    return this.httpService.get<ShippingPack[]>(`${this.apiUrl}/GetForUserSupplier`);
  }
}
